import { Link } from 'react-router-dom';

// Official Higgins Truck Sales logo artwork (June 2026 brand guide, HTS stacked logo).
// Per style guide: reverse (white) version on dark backgrounds, full colour on white.
export const Logo = ({ light = true, to = '/', className = '' }) => (
  <Link to={to} data-testid="site-header-logo" className={`inline-flex items-center shrink-0 ${className}`}>
    <img
      src={light ? '/brand/hts-logo-white.png' : '/brand/hts-logo.png'}
      alt="Higgins Truck Sales"
      className="h-10 sm:h-11 w-auto"
    />
  </Link>
);
